import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "AI Readiness Audits", desc: "A realistic assessment of where AI will create leverage in your operations, customer experience, or product." },
  { title: "Use-Case Prioritisation", desc: "We help sequence ideas by impact, feasibility, risk, and implementation cost before any build begins." },
  { title: "System Architecture", desc: "Model selection, orchestration, vector storage, safeguards, and workflow design shaped to your business." },
  { title: "Process Mapping", desc: "We identify manual or repetitive workflows that are strong candidates for automation and agentic execution." },
  { title: "Pilot Planning", desc: "Rapid proof-of-concept plans with scope, timeline, stack, and measurement criteria defined upfront." },
  { title: "Governance & Rollout", desc: "Operational guardrails, handoff plans, and adoption support so AI does not stay stuck in demo mode." },
];

const AiConsulting = () => (
  <StitchFeaturePage
    label="AI STRATEGY CONSULTING"
    title="Move from AI ideas"
    titleAccent="to execution."
    subtitle="Strategy, prioritisation, and architecture support for teams that want real AI systems, not vague experimentation."
    features={features}
    ctaLabel="BOOK AN AI STRATEGY SESSION"
  />
);

export default AiConsulting;
